import styles from './button.module.css';

export type ButtonVariant = 'primary' | 'secondary' | 'dark' | 'ghost';

/** Class names for a design-system pill button; works on <button>, <a> and router links. */
export function buttonClass(variant: ButtonVariant = 'primary', extra?: string): string {
  return [styles.button, styles[variant], extra].filter(Boolean).join(' ');
}
